var text;
$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $("body").on("click", ".swa-confirm", function (e) {
        e.preventDefault();
        var form = $(this).closest("form");

        Swal.queue([
            {
                title: $(this).data("title"),
                icon: "warning",
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return fetch(form[0].action, {
                        method: "post",
                        body: new URLSearchParams(form.serialize()),
                    })
                        .then((data) => {
                            window.location.reload();
                        })
                        .catch((e) => {
                            Swal.fire(
                                "Oops...",
                                "An error has occurred, please try again later.",
                                "error"
                            );
                        });
                },
            },
        ]);
    });
    //bsCustomFileInput.init();

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    _beforeSubmit = function (e) {
        var button = $(e.srcElement).find("button");
        text = button.html();
        try {
            button.prop("disabled", true);
            button.html('<i class="fas fa-circle-notch fa-spin"></i>');

            let iframe = document.querySelector(
                'iframe[src^="https://www.google.com/recaptcha"][src*="bframe"]'
            );
            let container = iframe.parentNode.parentNode;
            let observer = new MutationObserver((mutations) => {
                if (container && container.style.visibility === "hidden") {
                    //console.log(container);
                    button.prop("disabled", false);
                    button.html(text);
                }
            });
            observer.observe(container, {
                attributes: true,
                attributeFilter: ["style"],
            });

            return true;
        } catch (error) {
            button.prop("disabled", false);
            button.html(text);
            return false;
        }
    };

    $(document).on("submit", "form", function (e) {
        if (!$(e.target).find("div[id=_g-recaptcha]").length) {
            var button = $(e.target).find("button[type=submit]");
            button.prop("disabled", true);
            button.html('<i class="fas fa-circle-notch fa-spin"></i>');
        }
    });

    /* $(document).on('submit', '.cancel-order', function (e) {
         e.preventDefault();
         var form = this;

         Swal.fire({
             title: "Are you sure?",
             text: 'Are you sure you want to order a reservation?',
         }).then((isConfirm) => {
             if (isConfirm) {
                 form.submit();
             }
         });
     });*/

    $(document).on("click", ".cart-minus", function () {
        var $input = $(this).parent().find("input");
        var count = parseInt($input.val()) - 1;
        count = count < 1 ? 1 : count;
        $input.val(count);
        $input.change();
        return false;
    });
    $(document).on("click", ".cart-plus", function () {
        var $input = $(this).parent().find("input");
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
    });
});
